/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmEmailRequestsType from '@jira/spa-apps__admin-pages-product-jsm-email-requests/src/ProductsJsmEmailRequestsType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmEmailRequests: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJsmEmailRequestsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-email-requests", jiraSpaEntry: "async-products-jsm-email-requests" */ '@jira/spa-apps__admin-pages-product-jsm-email-requests/src/ProductsJsmEmailRequestsType.tsx'
		),
	),
);

const AsyncProductsJsmEmailRequests = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmEmailRequests}
		pageId="products-jsm-email-requests"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmEmailRequests;
